import axios from "axios";
import { GLOBAL_URL, WEB_APP_VERSION, JW_BASE_URL } from "./constants";
import store from "reduxStore/store";
import { userLogout } from "reduxStore/action/authActions";
import {
  successToast,
  errorToast,
  warnToast,
  infoToast,
  greMobileOtpSettingToast,
} from "./toastNotify";
import {
  showGlobalLoaderForRequest,
  hideGlobalLoaderIfIdle,
  resetGlobalLoader,
} from "./globalLoader";

export {
  successToast,
  errorToast,
  warnToast,
  infoToast,
  greMobileOtpSettingToast,
  resetGlobalLoader,
};

const httpClient = axios.create({
  baseURL: `${GLOBAL_URL}/api/`,
});

const httpClientJW = axios.create({
  baseURL: JW_BASE_URL,
  timeout: 30000,
});

if (WEB_APP_VERSION) {
  httpClient.defaults.headers.common["X-App-Version"] = WEB_APP_VERSION;
  httpClient.defaults.headers.common["X-Device-Type"] = "web";
}

export function setDefaultHeader(header, value) {
  httpClient.defaults.headers.common[header] = value;
}

export async function apiCall(
  method,
  url,
  data,
  header = {
    "Content-Type": "application/json",
  },
  options = {},
) {
  const controller = new AbortController();
  const { response } = store.getState().login;
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;

  let requestData = data;
  let skipGlobalLoader = false;
  let loaderMessage = "";

  // FormData (e.g. GRE banner upload) must pass through unchanged for multipart posts.
  if (!isFormData) {
    requestData = { ...(data || {}) };
    skipGlobalLoader =
      requestData.isLoadMore || requestData.suppressGlobalLoader;
    loaderMessage = requestData.loaderMessage || "";
    delete requestData.suppressGlobalLoader;
    delete requestData.loaderMessage;
  }

  let headers = {
    ...header,
    token: response?.token,
  };

  if (isFormData) {
    // Let the browser set multipart boundary; do not force application/json.
    delete headers["Content-Type"];
  }

  let loaderRequestId = null;
  if (!skipGlobalLoader) {
    loaderRequestId = showGlobalLoaderForRequest(url, loaderMessage);
  }
  try {
    return await httpClient({
      method,
      url,
      data: requestData,
      headers: headers,
      withCredentials: false,
      signal: controller.signal,
      responseType: options.responseType || "json",
      validateStatus:
        options.validateStatus ||
        ((status) => status >= 200 && status < 300),
    });
  } finally {
    if (!skipGlobalLoader) {
      hideGlobalLoaderIfIdle(loaderRequestId);
    }
  }
}

/** JW API client — mobile uses this directly; web must proxy via JV-Backend (CORS). */
export async function apiCallJW(
  method,
  url,
  data,
  header = {
    "Content-Type": "application/json",
  },
) {
  try {
    return await httpClientJW({
      method,
      url,
      data,
      headers: header,
    });
  } catch (error) {
    if (error.response) {
      return error.response;
    }
    return {
      data: {
        status: 500,
        message:
          error.message || "Unable to connect to JW. Please try again.",
      },
      status: 500,
    };
  }
}

export const unAuthorizedError = (data) => {
  errorToast(data?.message || "Your session has expired.", {
    title: "Session expired",
    autoClose: 5000,
  });
  if (data.status === 401 || data.status === 400 || data.status === 403) {
    store.dispatch(userLogout());
    window.localStorage.clear();
    window.location.reload();
  }
};
